module.exports = __webpack_public_path__ + "img/welcome2.301f5631.jpg";